import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICheckList } from "types/formTypes";
import { IClient } from "types/tablesTypes";
import { IUserData, Notification } from "types/userTypes";

interface UserState {
    jwt: string | null;
    userData: IUserData | null;
    feeDetails: { totalFeeSum: number, remainingFeeSum: number } | null;
    graphDetails: { month: string, totalFeeSum: number }[] | null;
    clients: IClient[];
    checkList: ICheckList[];
    error: string | null;
    notifications: Notification[]
}

const initialState: UserState = {
    jwt: null,
    userData: null,
    feeDetails: null,
    graphDetails: null,
    clients: [],
    checkList: [],
    error: null,
    notifications: [],
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string | null>) => {
            state.jwt = action.payload;
        },
        setUser: (state, action: PayloadAction<IUserData>) => {
            state.userData = action.payload;
        },
        setFeeDetails: (state, action: PayloadAction<{ totalFeeSum: number, remainingFeeSum: number }>) => {
            state.feeDetails = action.payload;
        },
        setGraphDetails: (state, action: PayloadAction<{ month: string, totalFeeSum: number }[]>) => {
            state.graphDetails = action.payload;
        },
        setCheckList: (state, action: PayloadAction<ICheckList[]>) => {
            state.checkList = action.payload;
        },
        logout: (state) => {
            return initialState;
        },
        setClients: (state, action: PayloadAction<IClient[]>) => {
            state.clients = action.payload;
        },
        addClient: (state, action: PayloadAction<IClient>) => {
            state.clients.push(action.payload);
        },
        fetchUserDetails: (state) => {
            // No state modification; just an action trigger for saga
        },
        fetchNotifications: (state) => {
            // No state modification; just an action trigger for saga
        },
        fetchUserFailed(state, action) {
            state.error = action.payload;
        },
        setNotifications: (state, action: PayloadAction<Notification[]>) => {
            state.notifications = action.payload;
        },
        updateReadStatus: (state, action: PayloadAction<{ id: number; read: boolean }>) => {
            const { id, read } = action.payload;
            state.notifications = state.notifications.map(notification =>
                notification.id === id ? { ...notification, attributes: { ...notification.attributes, Read: read } } : notification
            );
        },
    }
})

export const {
    setToken,
    setUser,
    setFeeDetails,
    setGraphDetails,
    logout,
    setClients,
    addClient,
    setCheckList,
    fetchUserDetails,
    fetchNotifications,
    fetchUserFailed,
    setNotifications,
    updateReadStatus
} = userSlice.actions;
export default userSlice.reducer;
